import { css } from 'linaria';

export const downloadCatalogBody = css`
  display: flex;
  align-items: center;
  padding-left: 16px;

  @media (--only-mobile) {
    align-items: flex-start;
  }
`;

export const downloadCatalogText = css`
  padding-left: 8px;

  && {
    @media (--to-largeDesktop) {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

export const downloadCatalogImageWrapper = css`
  display: flex;
  height: 100%;
`;

export const downloadCatalogImage = css`
  width: 198px;
  height: 96px;
  margin-right: 25px;
  object-fit: contain;
  align-self: flex-end;

  @media (--only-desktop) {
    width: 116px;
    height: 83px;
  }

  @media (--only-tablet) {
    display: none;
  }

  @media (--only-mobile) {
    width: 90px;
    height: 93px;
    margin-right: 14px;
  }
`;
